// extracted by mini-css-extract-plugin
export default {"checkboxRow":"DictionaryEntryRow_checkboxRow__B48RZ","radio":"DictionaryEntryRow_radio__f1byz","radio_hidden":"DictionaryEntryRow_radio_hidden__AQ398"};